// 金额以万分之一整数比较，99.9999不能因为显示舍入被认作100元达标。
function amount(value) {
  const text = String(value ?? '');
  if (!/^\d{1,16}(?:\.\d{1,4})?$/.test(text)) return null;
  const [whole, fraction = ''] = text.split('.');
  return { units: BigInt(whole) * 10000n + BigInt(fraction.padEnd(4, '0')), text: text.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '') };
}

// 只投影服务端本人事实；资格结论仍由canApply/unavailableReason决定。
export function giftProgressView(prize, safeUrl) {
  const mode = Number(prize?.progressBarChoose), theme = Number(prize?.progressBarTemplate);
  const icon = mode === 2 ? safeUrl(prize?.progressIconPicture) : '';
  const bar = mode === 2 ? safeUrl(prize?.progressBarPicture) : '';
  if (!(mode === 1 && [1, 2].includes(theme)) && !(mode === 2 && icon && bar)) return null;
  const rows = (Array.isArray(prize?.giftProgress) ? prize.giftProgress : []).flatMap((fact) => {
    const current = amount(fact?.currentAmount), required = amount(fact?.requiredAmount);
    const title = typeof fact?.title === 'string' ? fact.title.trim() : '';
    if (!title || !current || !required || required.units <= 0n) return [];
    const complete = current.units >= required.units;
    return [{ title, current: current.text, required: required.text, percent: complete ? 100 : Number(current.units * 10000n / required.units) / 100 }];
  });
  return rows.length ? { theme: mode === 2 ? 'custom' : theme === 2 ? 'world-cup' : 'classic', icon, bar, rows } : null;
}
